import { ReactNode } from 'react';
import { IComponentCss, MainTheme } from '@tap/mui-ui';
import { Button, Grid2 } from '@mui/material';
import { Widget, WidgetVariant } from '@tap/mui-ui';

/**
 *  Поиск
 */

type IFilterWidgetProps = {
    title?: string,
    children: ReactNode,
    handleCleanFilter: () => void,
    handleUpdateFilter: () => void,
}


const css: IComponentCss = {
    filterInputWrap: {
        marginTop: '-10px',
    },
    resetButton: {
        position: 'absolute',
        top: '15px',
        right: '13px',
        textTransform: 'none',
    },
}


export function FilterWidget({
    title = 'Поиск',
    children,
    handleCleanFilter,
    handleUpdateFilter,
}: IFilterWidgetProps) {

    return (
        <Grid2 size={{ xs: 12, md: 12, sm: 12 }}>
            <Widget title={title} variant={WidgetVariant.Filter}>
                <>
                    {/* Кнопка сбросить */}
                    <Button
                        variant='text'
                        onClick={handleCleanFilter}
                        sx={{
                            ...css.resetButton,
                            color: MainTheme.palette.primary.main,
                        }}
                    >
                        сбросить
                    </Button>

                    <Grid2 container
                        spacing={1.5}
                        sx={css.filterInputWrap}>

                        {children}

                        <Grid2 container size={{ xs: 12, sm: 12, md: 6 }}>
                            <Button
                                onClick={handleUpdateFilter}
                                variant="contained"
                                disableElevation
                                fullWidth
                            >
                                Обновить
                            </Button>
                        </Grid2>

                    </Grid2>
                </>
            </Widget>
        </Grid2>
    );
}
